import { matchPath } from "react-router-dom";

export const PUBLIC_ROUTES = {
  LANDING: "/",
  NOTEBOOK: "/notebook/:notebook",
  AGENTS: "/agents",
  PHYSICAL_AI: "/physical-ai",
  NEMOCLAW: "/nemoclaw",
  LAUNCHABLE_DEPLOY: "/launchable/deploy",
  CREATE_INSTANCE_PUBLIC: "/environment/new/public",
  LAUNCHABLES: "/launchables",
  LOGIN: "/login",
  LOGOUT: "/logout",
  REDEEM_CODE: "/redeem-code",
  ERROR: "/error/:httpStatus",
  HELP: "/help",
  ACCEPT_INVITATION_REJECTED: "/accept-invitation/rejected",
  ORG_ACCEPT_INVITATION: "/org/:orgId/accept-invitation",
};

export function isPublicRoute(pathname) {
  if (pathname === "/") {
    return true;
  }

  if (pathname === "/environment/new") {
    return false;
  }

  return Object.values(PUBLIC_ROUTES).some((route) =>
    matchPath(pathname, { path: route, exact: true }),
  );
}
